import {configParamsModule} from "../../configParamsModule"
import {LoadingService, MessagesModal, RemoteExceptionHandler} from "../../../../bower_components/front-end-web-commons";
import {BiModel} from "../../configParamsService";
import {PermissionGroupSupportService} from "../support/permissionGroupSupportService";

class NlgMicrostrategyConfiguration {
    model: BiModel = {
        id: null,
        segment: "",
        profile: "",
        company: "",
        product: "",
        quantityOfLicenses: 0,
        allowedUsers: []
    }
    private users: any = [];

    constructor(private loadingService: LoadingService,
                private remoteExceptionHandler: RemoteExceptionHandler,
                private messagesModal: MessagesModal,
                private permissionGroupSupportService: PermissionGroupSupportService,
                private $state: any) {
        this.loadingService(this.permissionGroupSupportService.getBiConfigurations())
            .catch(this.remoteExceptionHandler())
            .then((configurations: any) => {
                this.model = configurations;
            });

        this.loadingService(this.permissionGroupSupportService.getUsers())
            .catch(this.remoteExceptionHandler())
            .then((users: any) => {
                this.users = users;
            });
        this.model.allowedUsers = []
    }

    getBiConfigurations() {
        return this.permissionGroupSupportService.getBiConfigurations()
    }

    canMoveUser() {
        return this.model.allowedUsers.length < this.model.quantityOfLicenses
    }

    saveBiConfigurations() {
        return this.loadingService(this.permissionGroupSupportService.saveBiConfigurations(this.model))
            .catch(this.remoteExceptionHandler())
            .then(() => this.messagesModal("dialog.success", ["bi.configurations.saved"]).then(() => this.$state.reload()));
    }

}

export const directive = configParamsModule.directive("nlgMicrostrategyConfiguration", [function () {
    return {
        restrict: "E",
        templateUrl: require("link!./nlgMicrostrategyConfiguration.html"),
        scope: {},
        controllerAs: "ctrl",
        controller: NlgMicrostrategyConfiguration
    }
}])